
import { defineComponent, PropType } from 'vue'
import { DynamicRiskLevel } from '~/types/types'
import { getDynamicRiskTagInfo } from '~/utils/ui'

export default defineComponent({
  name: 'DynamicRiskPill',
  props: {
    dynamicRisk: {
      type: String as PropType<DynamicRiskLevel>,
      required: true
    }
  },
  computed: {
    pillInfo() {
      return getDynamicRiskTagInfo(this.dynamicRisk)
    }
  }
})
